import * as React from 'react';
import { PropsWithChildren } from 'react';
import { Loading } from './Loading';

export type LoadingContentProps = {
    loading: boolean,
    classes: string
}

export const LoadingContent: React.FC<PropsWithChildren<LoadingContentProps>> = (props) => {
    return (<>{props.loading ? <Loading classes={props.classes} /> : props.children}</>);
};
